
import {Component, Mixins} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import Dates from "@/components/inputs/Dates.vue";
import {SonIslemTarihiAyariEntity} from "@/entity/SonIslemTarihiAyariEntity";

@Component({
  components: {Dates, FormWrapper},
})
export default class SonIslemTarihiAyariForm extends Mixins(ObjectInputMixin) {
  localValue: SonIslemTarihiAyariEntity = new SonIslemTarihiAyariEntity();

  save(){
    this.$http.post("/api/v1/uyarilar/uyari-gereksinimleri",this.localValue).then(() => {})
  }
}
